export default __webpack_public_path__ + "static/media/Cognitive_Img@2x.b0a5e064.png";